import { actions } from './slices';
import { uploadUserSummaryAsync } from './thunks';

export const UserSummariesActions = {
  ...actions,
  uploadUserSummaryAsync,
};
